
import Vue from "vue";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

import router from '@/router'
// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";


const state = {
  access_token: null,
  errors: null,

  user: {},
  permissions: [],
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  permissions(state) {
    return state.permissions;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("auth/login", credentials)
        .then(({ data }) => {
          Vue.prototype.$session.start();
          context.commit(SET_AUTH, data);
          context.rootState.userinfo.permissions = data.Permission;
          Vue.prototype.$session.set("permissions", data.Permission);
          Vue.prototype.$forceUpdate();
          resolve(data);
        })
        .catch(({ response }) => {
          //  console.log(response);
          context.commit(SET_ERROR, response.data.error);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("auth/login", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);

        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.error);
        });
    });
  },
  [VERIFY_AUTH](context) {

    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.post("auth/verify")
        .then(({ data }) => {
          context.commit(SET_AUTH, data);

          Vue.prototype.$session.set("permissions", data.Permission);
          Vue.prototype.$forceUpdate();

        })
        .catch(({ response }) => {
          //   console.log('response catch',response);

          if (response.status == 401) {
            context.commit(PURGE_AUTH);
            context.commit(SET_ERROR, response.data.message);
            router.push({ path: "/login" });
          }
        });
    } else {
      context.commit(PURGE_AUTH);

    }
  },
  [UPDATE_PASSWORD](context, payload) {
    const password = payload;

    return ApiService.put("password", password).then(({ data }) => {
      context.commit(SET_PASSWORD, data);
      return data;
    });
  },

};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.permissions = user.Permission;
    state.errors = {};
    state.access_token = user.access_token;
    JwtService.saveToken(user.access_token);
  },
  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    state.permissions = null;
    state.access_token = null;
    JwtService.destroyToken();
  }

};

export default {
  state,
  actions,
  mutations,
  getters
};
